import { MONTHLY, MONTHS } from 'constants/constants';

export const recurringFrequencyStr = (interval) =>
  interval === 1 ? MONTHLY : `${interval}${MONTHS}`;
